import { motion } from 'motion/react';
import { ChevronLeft, Zap, BookOpen, Video, ShieldCheck } from 'lucide-react';

export default function DocsAndTutorials({ onBack }: { onBack: () => void }) {
  return (
    <motion.div 
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
      className="p-6 text-white"
    >
      <button 
        onClick={onBack}
        className="flex items-center gap-2 text-white/50 hover:text-white mb-8 text-xs uppercase font-bold tracking-widest"
      >
        <ChevronLeft size={16} /> Volver a Soporte
      </button>

      <h2 className="text-3xl font-black uppercase tracking-tighter mb-8">Documentación & Tutoriales</h2>

      <div className="space-y-8">
        {[
          { 
            title: "Configuración Inicial", 
            icon: Zap, 
            desc: "1. Haz clic en el botón de 'Vincular' (icono QR) en la pantalla principal. 2. Escanea el código QR que aparecerá o usa el código de emparejamiento desde tu móvil. 3. Accede al Portal Aura Business, selecciona 'Nuevo Aura' y vincula tu dispositivo." 
          },
          { 
            title: "Gestión de Playlist", 
            icon: BookOpen, 
            desc: "Accede al panel de gestión desde el Admin. No es necesario subir archivos propios; utiliza la pestaña 'Impulsos' para seleccionar pistas de audio predefinidas y la pestaña 'Slides' para elegir el contenido visual. Asocia estas selecciones a tus horarios en el ciclo circadiano." 
          },
          { 
            title: "Video Tutoriales", 
            icon: Video, 
            desc: "Guías visuales paso a paso para dominar el panel de control.",
            isComingSoon: true
          },
          { 
            title: "Solución de Problemas", 
            icon: ShieldCheck, 
            desc: "Si la pantalla no muestra nada: asegúrate de que tiene alimentación. Si muestra un mensaje de 'Sin Conexión': reinicia tu router o verifica las credenciales de Wi-Fi en el panel de gestión." 
          },
        ].map((item, i) => (
          <div key={i} className="group rounded-3xl bg-white/5 border border-white/10 p-6 transition-all hover:bg-white/10 relative">
            <div className="flex gap-4">
              <item.icon className="text-yellow-500 mt-1" size={24} />
              <div>
                <h3 className="font-bold text-lg flex items-center gap-3">
                  {item.title}
                  {item.isComingSoon && (
                    <span className="text-[9px] bg-yellow-500/20 text-yellow-500 px-2 py-0.5 rounded-full uppercase tracking-wider font-bold">En construcción</span>
                  )}
                </h3>
                <p className="text-white/40 text-sm mt-1">{item.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
}
